<form class="row mx-0 px-0 h-100 w-100 d-flex justify-content-center align-items-start" [formGroup]="benefitForm"
  (ngSubmit)="isValid()">
  <div class="col-12 mb-5 text-center">
    <h4>{{benefitData ? 'Edición ' : 'Creación '}}de Institución</h4>
  </div>
  <div class="col-12 col-xl-5 vs-outline-editCard h-fit-content mx-1">
    <img class="given-img" [src]="fileImg64C" alt="img-benefit-slide" *ngIf="fileImg64C">
    <div class="btn-custom-file h-100 w-100">
      <label for="file-upload" class="custom-file-upload mt-5">
        <mat-icon>{{fileImg64C ? '': 'image'}} </mat-icon>
        <span class="my-2 text-center">{{benefitData ? 'Editar ' : 'Agregar'}} imagen carrusel de 72px x 48px</span>
      </label>
      <input id="file-upload" type="file" accept="image/*" (change)="getBase64($event, 'carrousel')" />
    </div>
  </div>
  <div class="col-12 col-xl-5 vs-outline-editCard h-fit-content mx-1">
    <img class="given-img" [src]="fileImg64M" alt="img-benefit-slide" *ngIf="fileImg64M">
    <div class="btn-custom-file h-100 w-100">
      <label for="file-upload-modal" class="custom-file-upload mt-5">
        <mat-icon>{{fileImg64M ? '': 'image'}} </mat-icon>
        <span class="my-2 text-center">{{benefitData ? 'Editar ' : 'Agregar'}} imagen modal de 165px x 110px</span>
      </label>
      <input id="file-upload-modal" type="file" accept="image/*" (change)="getBase64($event, 'modal')" />
    </div>
  </div>
  <div class="col-12 mt-3 text-center d-flex flex-column">
    <span class="text-danger" *ngIf="wrongSize['c']">{{wrongSize['c']}}</span>
    <span class="text-danger" *ngIf="wrongSize['m']">{{wrongSize['m']}}</span>

  </div>
  <div class="col-12 mb-2 mt-4 px-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Nombre de institución</mat-label>
      <input formControlName="name" matInput placeholder="Ingresar nombre...">
    </mat-form-field>
  </div>
  <button type="submit" class="vs-btn-blue" [disabled]="benefitForm.invalid">
    Guardar
  </button>
</form>
